import script from "./SkeletonLoad.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonLoad.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonLoad.vue?vue&type=style&index=0&id=f58ec8ee&lang=css"

const __exports__ = script;

export default __exports__